import { render } from "./buisness.vue?vue&type=template&id=0144d7dc"
import script from "./buisness.vue?vue&type=script&lang=js"
export * from "./buisness.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__